"use client";

import { c as _c } from "react/compiler-runtime";
import { LogOut } from "lucide-react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/ui/logo";
import { useAuth } from "@/lib/auth-client";
import type { ReactNode } from "react";

// Clean user-facing shell for the console (NOT the admin sidebar). Just a top
// bar with the brand + sign-out; the page content sits underneath.
export function ConsoleShell(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const router = useRouter();
  const {
    signOut
  } = useAuth();
  let t1;
  if ($[0] !== router || $[1] !== signOut) {
    t1 = async () => {
      await signOut({
        fetchOptions: {
          onSuccess: () => router.push("/login")
        }
      });
    };
    $[0] = router;
    $[1] = signOut;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSignOut = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/" className="flex items-center gap-2"><Logo className="h-7 w-7" /><span className="text-sm font-semibold tracking-tight">RouterBench</span></Link>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <LogOut className="h-4 w-4" />;
    t4 = <span>Sign out</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleSignOut) {
    t5 = <header className="bg-background/80 sticky top-0 z-10 border-b backdrop-blur"><div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-6">{t2}<Button variant="ghost" size="sm" onClick={handleSignOut} className="text-muted-foreground gap-2">{t3}{t4}</Button></div></header>;
    $[6] = handleSignOut;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== children || $[9] !== t5) {
    t6 = <div className="bg-background min-h-screen">{t5}{children}</div>;
    $[8] = children;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}